import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import type { Session } from "@packages/core/session/session.ts";
import { useFeatureFlags } from "@squide/firefly";

const ALLOWED_WL_MEMBER_IDS = new Set([
    "6d8807c8-0bf5-4e2f-836c-87569cd3efbc",
    "81045fd5-e65f-4d05-8a75-54672f10ab6c",
    "06bb51c8-e7c2-4a14-a716-d4e591b9f2af",
    "54377c4f-a1d6-41fa-b95f-b65a2918f543",
    "b86c929b-08c0-41df-9ae5-d19645fa1b2f",
    "0007960d-e3a8-4e4f-9d2c-e5df596cd710",
    "3c5e413e-4057-4644-b0d3-858eb493f2b1",
    "05d467da-5f34-4b09-a157-3d31379936f5",
    "e5355d19-1675-4e6e-96fb-96349739c2e6",
    "db808d3e-7d0f-4bba-b471-99c62ba188d3",
    "f2364a8b-c120-4d52-a070-aaa27793fedf",
    "5a2fe86c-c143-4f50-ae3f-687047b9d62f"
]);

export function isMeetingsInPerformanceEnabled(isFeatureFlagEnabled: boolean, session: Session | null | undefined) {
    return isFeatureFlagEnabled || (!!session?.memberId && ALLOWED_WL_MEMBER_IDS.has(session.memberId.toLowerCase()));
}

export function useIsMeetingsInPerformanceEnabled() {
    const isFeatureFlagEnabled = useFeatureFlags()["meetings-in-performance"];
    const session = useSession();

    return isMeetingsInPerformanceEnabled(isFeatureFlagEnabled, session);
}
